import { ReporteBalanceKRService } from './services/reporte-balance-kr.service';
import { ReporteResumenObraService } from './services/reporte-resumen-obra.service';
import { LiquidacionRevisionMovimientosObraService } from './services/liquidacion-revision-movimientos-obra.service';
import { LiquidacionRevisionFotografiasService } from './services/liquidacion-revision-fotografias.service';
import { LiquidacionCapturaService } from './services/liquidacion-captura.service';
import { LiquidacionRevisionService } from './services/liquidacion-revision.service';
import { LiquidacionCapturaMovimientosObraService } from './services/liquidacion-captura-movimientos-obra.service';
import { UsuariosService } from './services/usuarios.service';
import { AutenticacionGuard } from './services/autenticacion.guard';
import { AutenticacionService } from './services/autenticacion.service';
import { SecurityModalComponent } from './components/partials/security-modal/security-modal.component';
import { InversionistasGruposService } from './services/inversionistas-grupos.service';
import { ProveedoresGruposService } from './services/proveedores-grupos.service';
import { CatalogoObrasInversionistasComponent } from './components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas.component';
import { CatalogoObrasComponent } from './components/catalogo-obras/catalogo-obras.component';
import { CatalogoProveedoresComponent } from './components/catalogo-proveedores/catalogo-proveedores.component';
import { CatalogoProveedoresGruposComponent } from './components/catalogo-proveedores-grupos/catalogo-proveedores-grupos.component';
import { CatalogoCuentasComponent } from './components/catalogo-cuentas/catalogo-cuentas.component';
import { CatalogoConceptosComponent } from './components/catalogo-conceptos/catalogo-conceptos.component';
import { ConceptosService } from './services/conceptos.service';
import { CuentasService } from './services/cuentas.service';
import { ValidatorService } from './services/tools/validator.service';
import { InversionistasService } from './services/inversionistas.service';
import { ChequesTemplatesService } from './services/cheques-templates.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { HttpModule, Http } from '@angular/http';
import { AppComponent } from './app.component';

import { routing, appRoutingProviders } from './app.routing';
import { GeneralServices } from './services/general.services';
import { ConstantsService } from './services/constants.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeftSidebarComponent } from './components/partials/left-sidebar/left-sidebar.component';
import { RightSidebarComponent } from './components/partials/right-sidebar/right-sidebar.component';
import { MobileBarComponent } from './components/partials/mobile-bar/mobile-bar.component';
import { ObrasService } from './services/obras.service';
import { TouchspinComponent } from './components/tools/touchspin/touchspin.component';
import { SuccessModalComponent } from './components/tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from './components/tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from './components/tools/modals/confirm-modal/confirm-modal.component';
import { ErrorsService } from './services/tools/errors.service';
import { Select2SingleComponent } from './components/tools/select2/select2-single/select2-single.component';
import { ProveedoresService } from './services/proveedores.service';
import { CatalogoListaDefaultComponent } from './components/partials/catalogo-lista-default/catalogo-lista-default.component';
import { CatalogoDetallesDefaultComponent } from './components/partials/catalogo-detalles-default/catalogo-detalles-default.component';
import { SwitcherComponent } from './components/tools/switcher/switcher.component';
import { PaginationComponent } from './components/partials/pagination/pagination.component';
import { CatalogoInversionistasComponent } from './components/catalogo-inversionistas/catalogo-inversionistas.component';
import { CatalogoInversionistasGruposComponent } from './components/catalogo-inversionistas-grupos/catalogo-inversionistas-grupos.component';
import { DatepickerComponent } from './components/tools/datepicker/datepicker.component';
import { BotonExcelComponent } from './components/tools/boton-excel/boton-excel.component';
import { WarningModalComponent } from './components/tools/modals/warning-modal/warning-modal.component';
import { Select2GroupsComponent } from './components/tools/select2/select2-groups/select2-groups.component';
import { CatalogoObrasInversionistasGruposComponent } from './components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-grupos/catalogo-obras-inversionistas-grupos.component';
import { CatalogoObrasInversionistasIndividualComponent } from './components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-individual/catalogo-obras-inversionistas-individual.component';
import { CatalogoObrasFotografiaComponent } from './components/catalogo-obras/catalogo-obras-fotografia/catalogo-obras-fotografia.component';
import { MovimientosObraComponent } from './components/movimientos-obra/movimientos-obra.component';
import { MovimientosObraService } from './services/movimientos-obra.service';
import { MovimientosObraProyeccionesComponent } from './components/movimientos-obra-proyecciones/movimientos-obra-proyecciones.component';
import { MovimientosObraProyeccionesService } from './services/movimientos-obra-proyecciones.service';
import { Select2MultiComponent } from './components/tools/select2/select2-multi/select2-multi.component';
import { HelpersService } from './services/tools/helpers.service';
import { PrintReciboModalComponent } from './components/partials/print-recibo-modal/print-recibo-modal.component';
import { PrintChequeModalComponent } from './components/partials/print-cheque-modal/print-cheque-modal.component';
import { InputCurrencyComponent } from './components/tools/input-currency/input-currency.component';
import { Select2MultiGroupsComponent } from './components/tools/select2/select2-multi-groups/select2-multi-groups.component';
import { LiquidacionCapturaComponent } from './components/liquidacion-captura/liquidacion-captura.component';
import { MovimientosObraLiquidacionComponent } from './components/liquidacion-captura/movimientos-obra-liquidacion/movimientos-obra-liquidacion.component';
import { LiquidacionModalComponent } from './components/partials/liquidaciones-modal/liquidaciones-modal.component';
import { LoginComponent } from './components/autenticacion/login/login.component';
import { GenerarPasswordComponent } from './components/autenticacion/generar-password/generar-password.component';
import { SaveImageComponent } from './components/tools/save-image/save-image.component';

//import { Global } from './services/tools/Global.service';
import { Globals } from './services/tools/Globals.service';
import { RecuperarPasswordComponent } from './components/autenticacion/recuperar-password/recuperar-password.component';
import { CerrarSessionModalComponent } from './components/partials/cerrar-session-modal/cerrar-session-modal.component';
import { Message1ModalComponent } from './components/tools/modals/message1-modal/message1-modal.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { UsuariosPermisosComponent } from './components/usuarios/usuarios-permisos/usuarios-permisos.component';
import { ModulesService } from './services/tools/modules.service';
import { CookieService } from 'ngx-cookie-service';
import { NotasFotografiasComponent } from './components/liquidacion-captura/notas-fotografias/notas-fotografias.component';
import { LiquidacionRevisionComponent } from './components/liquidacion-revision/liquidacion-revision.component';
import { TexteditorComponent } from './components/tools/texteditor/texteditor.component';
import { ChartBarComponent } from './components/tools/charts/chart-bar/chart-bar.component';
import { ChartLineComponent } from './components/tools/charts/chart-line/chart-line.component';
import { LiquidacionCapturaFotografiasService } from './services/liquidacion-captura-fotografias.service';
import { LiquidacionCapturaFondoAhorroComponent } from './components/liquidacion-captura/liquidacion-captura-fondo-ahorro/liquidacion-captura-fondo-ahorro.component';
import { LiquidacionRevisionFondoAhorroComponent } from './components/liquidacion-revision/liquidacion-revision-fondo-ahorro/liquidacion-revision-fondo-ahorro.component';
import { LiquidacionRevisionMovimientosObraComponent } from './components/liquidacion-revision/liquidacion-revision-movimientos-obra/liquidacion-revision-movimientos-obra.component';
import { LiquidacionRevisionNotasFotografiasComponent } from './components/liquidacion-revision/liquidacion-revision-notas-fotografias/liquidacion-revision-notas-fotografias.component';
import { ConfirmTextModalComponent } from './components/tools/modals/confirm-text-modal/confirm-text-modal.component';
import { ReporteLiquidacionService } from './services/reporte-liquidacion.service';
import { ReporteLiquidacionComponent } from './components/reporte-liquidacion/reporte-liquidacion.component';
import { ReporteLiquidacionTablaDispersionesComponent } from './components/reporte-liquidacion-tabla-dispersiones/reporte-liquidacion-tabla-dispersiones.component';
import { ReporteLiquidacionComprobanteComponent } from './components/reporte-liquidacion-comprobante/reporte-liquidacion-comprobante.component';
import { ReporteLiquidacionComprobanteImagenComponent } from './components/reporte-liquidacion-comprobante-imagen/reporte-liquidacion-comprobante-imagen.component';
import { ReporteDepositoGarantia } from './components/reporte-deposito-garantia/reporte-deposito-garantia.component';
import { ReporteResumenOyv } from './components/reporte-resumen-oyv/reporte-resumen-oyv.component';
import { ReporteCobranzaComponent } from './components/reporte-cobranza/reporte-cobranza.component';
import { EstadoCuentaClientesComponent } from './components/estado-cuenta-clientes/estado-cuenta-clientes.component';
import { CatalogoReportesComponent } from './components/reportes/reportes.component';
import { ReportePorObraComponent } from './components/reporte-por-obra/reporte-por-obra.component';
import { ReporteSaldosComponent } from './components/reporte-saldos/reporte-saldos.component';
import { ReportePorInversionistaComponent } from './components/reporte-por-inversionista/reporte-por-inversionista.component';
import { ChartDonutComponent } from './components/tools/charts/chart-donut/chart-donut.component';
import { ProgressBarComponent } from './components/tools/progress-bar/progress-bar.component';
import { ReporteResumenObraComponent } from './components/reporte-resumen-de-obra/reporte-resumen-de-obra.component';
import { ReporteBalanceKRComponent } from './components/reporte-balance-kr/reporte-balance-kr.component';
import { ReporteEquilibrioKRComponent } from './components/reporte-equilibrio-kr/reporte-equilibrio-kr.component';
import { ReportesService } from './services/reportes.service';
import { ReportePorInversionistaService } from './services/reporte-por-inversionista.service';
import { ReportePorObraService } from './services/reporte-por-obra.service';
import { ReporteCobranzaService } from './services/reporte-cobranza.service';
import { EstadoCuentaClientesService } from './services/estado-cuenta-clientes.service';
import { ReporteDepositoGarantiaService } from './services/reporte-deposito-garantia.service';
import { ReporteResumenOyvService } from './services/reporte-resumen-oyv.service';
import { TouchspinV2Component } from './components/tools/touchspin-v2/touchspin-v2.component';
import { ReporteGeneralService } from './services/reporte-general.service';
import { ReporteResumenDeObraGruposModalComponent } from './components/reporte-resumen-de-obra/reporte-resumen-de-obra-grupos-modal/reporte-resumen-de-obra-grupos-modal.component';
import { DetallesKRModalComponent } from './components/reporte-equilibrio-kr/detalles-kr-modal/detalles-kr-modal.component';
import { DetallesBalanceKRModalComponent } from './components/reporte-balance-kr/detalles-balance-kr-modal/detalles-balance-kr-modal.component';
import { ReporteEquilibrioKRService } from './services/reporte-equilibrio-kr.service';
import { ReporteResumenDeObraRetornosModalComponent } from './components/reporte-resumen-de-obra/reporte-resumen-de-obra-retornos-modal/reporte-resumen-de-obra-retornos-modal.component';
import { MovimientosModalComponent } from './components/movimientos-obra/movimientos-modal/movimientos-modal.component';
import { ModalComprobantesLiquidacionComponent } from './components/tools/modal-comprobantes-liquidacion/modal-comprobantes-liquidacion.component';
import { AjaxLoaderComponent } from './components/tools/ajax-loader/ajax-loader.component';
import { SkeletonComponent } from './components/tools/skeleton/skeleton.component';
import { ListadoContratosComponent } from './components/contratos/listado/listado-contratos.component';
import { AgregarContratoComponent } from './components/contratos/agregar-contrato/agregar-contrato.component';
import { FormularioContratoComponent } from './components/contratos/agregar-contrato/formulario-contrato/formulario-contrato.component';
import { ListadoRentasComponent } from './components/contratos/agregar-contrato/listado-rentas/listado-rentas.component';
import { FormularioRentaComponent } from './components/contratos/agregar-contrato/listado-rentas/formulario-renta/formulario-renta.component';
import { FormularioConvenioComponent } from './components/convenios/formulario-convenio/formulario-convenio.component';
import { ListadoMantenimientosComponent } from './components/contratos/agregar-contrato/listado-mantenimientos/listado-mantenimientos.component';
import { FormularioMantenimientoComponent } from './components/contratos/agregar-contrato/listado-mantenimientos/formulario-mantenimiento/formulario-mantenimiento.component';
import { ListadoServiciosComponent } from './components/contratos/agregar-contrato/listado-servicios/listado-servicios.component';
import { FormularioServicioComponent } from './components/contratos/agregar-contrato/listado-servicios/formulario-servicio/formulario-servicio.component';
import { ListadoArchivosComponent } from './components/contratos/agregar-contrato/listado-archivos/listado-archivos.component';
import { ReporteCXCComponent } from './components/reporte-cxc/reporte-cxc.component';
import { EstadoCuentaCxcComponent } from './components/reporte-cxc/estado-cuenta-cxc/estado-cuenta-cxc.component';
import { ModalSeleccionCXCComponent } from './components/movimientos-obra/modal-seleccion-cxc/modal-seleccion-cxc.component';
import { ConveniosComponent } from './components/convenios/convenios.component';
import { GastosComponent } from './components/gastos/gastos.component';
import { FormularioGastoComponent } from './components/gastos/formulario-gasto/formulario-gasto.component';
import { ReporteCXPComponent } from './components/reporte-cxp/reporte-cxp.component';
import { ModalSeleccionCXPComponent } from './components/movimientos-obra/modal-seleccion-cxp/modal-seleccion-cxp.component';
import { CuentasPorPagarService } from './services/cuentas-por-pagar.service';
import { CatalogoService } from './services/tools/catalogos.service';
import { ReporteCuentasPorPagarService } from './services/reportes/reporte-cuentas-por-pagar.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { CuentasPorCobrarService } from './services/cuentas-por-cobrar.service';
import { ModalNuevoConvenioComponent } from './components/contratos/modal-nuevo-convenio/modal-nuevo-convenio.component';
import { DetallesConvenioComponent } from './components/contratos/modal-nuevo-convenio/detalles-convenio/detalles-convenio.component';
import { CatalogoProductosComponent } from './components/catalogo-productos/catalogo-productos.component';
import { FormularioProductoComponent } from './components/catalogo-productos/formulario-producto/formulario-producto.component';
import { FormularioServicioGeneralComponent } from './components/modulo-servicios/formulario-servicio-general/formulario-servicio-general.component';
import { ModalSeleccionProductosComponent } from './components/modulo-servicios/formulario-servicio-general/modal-seleccion-productos/modal-seleccion-productos.component';
import { ModalConfirmarServicioComponent } from './components/modulo-servicios/formulario-servicio-general/modal-confirmar-servicio/modal-confirmar-servicio.component';
import { TablaServiciosComponent } from './components/modulo-servicios/tabla-servicios/tabla-servicios.component';
import { ModalFacturacionComponent } from './components/reporte-cxc/modal-facturacion/modal-facturacion.component';
import { ModalNotaCreditoComponent } from './components/reporte-cxc/modal-nota-credito/modal-nota-credito.component';
import { ModalInteresesMoratoriosComponent } from './components/reporte-cxc/modal-intereses-moratorios/modal-intereses-moratorios.component';
import { CatalogosSatService } from './services/catalogos-sat-service';
import { ProductosService } from './services/productos.service';
import { FormularioFotografiasProductoComponent } from './components/catalogo-productos/formulario-producto/formulario-fotografias-producto/formulario-fotografias-producto.component';
import { VentasService } from './services/ventas.service';
import { ModalEditarCXPComponent } from './components/reporte-cxp/modal-editar-cxp/modal-editar-cxp.component';
import { ConfiguracionComponent } from './components/configuracion/configuracion.component';
import { ConfiguracionesService } from './services/configuraciones.service';
import { ModalEliminarCXPComponent } from './components/reporte-cxp/modal-eliminar-cxp/modal-eliminar-cxp.component';
import { ModalEliminarContratoComponent } from './components/contratos/listado/modal-eliminar-contrato/modal-eliminar-contrato.component';
import { ModalFacturarRecepcionPago } from './components/reporte-cxc/modal-facturar-recepcion-pago/modal-facturar-recepcion-pago.component';
import { ModalListadoFacturasPago } from './components/reporte-cxc/modal-listado-facturas-pago/modal-listado-facturas-pago.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ModalEliminarCxcComponent } from './components/reporte-cxc/modal-eliminar-cxc/modal-eliminar-cxc.component';
import { VisualizarContratoComponent } from './components/contratos/agregar-contrato/visualizar-contrato/visualizar-contrato.component';
import { ModalVerContratoComponent } from './components/contratos/listado/modal-ver-contrato/modal-ver-contrato.component';
import { ModalIngresoInterno } from './components/movimientos-obra/modal-ingreso-interno/modal-ingreso-interno.component';
import { ModalNuevoMovCarpetaBlancaComponent } from './components/movimientos-obra/modal-nuevo-mov-carpeta-blanca/modal-nuevo-mov-carpeta-blanca.component';

import { TicketAyudaModalComponent } from './components/partials/ticket-ayuda-modal/ticket-ayuda-modal.component';
import { TicketImplementacionModalComponent } from './components/partials/ticket-implementaciones-modal/ticket-implementaciones-modal.component';
import { SobreBlancoComponent } from './components/sobre-blanco/sobre-blanco.component';
import { SobreBlancoService } from './services/sobre-blanco.service';
registerLocaleData(localeEs, 'es-MX', localeEsExtra);

@NgModule({
  declarations: [
    AppComponent,

    // component catalogos
    CatalogoObrasComponent,
    CatalogoObrasInversionistasComponent,
    CatalogoCuentasComponent,
    CatalogoConceptosComponent,
    CatalogoProveedoresComponent,
    CatalogoProveedoresGruposComponent,
    CatalogoInversionistasComponent,
    CatalogoInversionistasGruposComponent,
    MovimientosObraComponent,
    LiquidacionCapturaComponent,
    MovimientosObraLiquidacionComponent,
    NotasFotografiasComponent,
    LiquidacionRevisionComponent,
    ReporteLiquidacionComponent,
    ReporteLiquidacionTablaDispersionesComponent,
    CatalogoReportesComponent,
    ReporteLiquidacionComprobanteComponent,
    ReporteLiquidacionComprobanteImagenComponent,
    ReporteDepositoGarantia,
    ReporteResumenOyv,
    ReporteCobranzaComponent,
    EstadoCuentaClientesComponent,
    //CXC & CXP
    ListadoContratosComponent,
    AgregarContratoComponent,
    FormularioContratoComponent,
    ListadoRentasComponent,
    FormularioRentaComponent,
    FormularioConvenioComponent,
    ListadoMantenimientosComponent,
    FormularioMantenimientoComponent,
    ListadoServiciosComponent,
    FormularioServicioComponent,
    ListadoArchivosComponent,
    ReporteCXCComponent,
    EstadoCuentaCxcComponent,
    ModalSeleccionCXCComponent,
    ConveniosComponent,
    GastosComponent,
    FormularioGastoComponent,
    ReporteCXPComponent,
    ModalSeleccionCXPComponent,
    CatalogoProductosComponent,
    FormularioProductoComponent,
    FormularioServicioGeneralComponent,
    ModalSeleccionProductosComponent,
    ModalConfirmarServicioComponent,
    TablaServiciosComponent,
    DetallesConvenioComponent,
    ModalEliminarCXPComponent,
    ModalEliminarContratoComponent,
    ModalFacturarRecepcionPago,
    ModalListadoFacturasPago,
    ModalEliminarCxcComponent,

    // component partials
    LeftSidebarComponent,
    RightSidebarComponent,
    MobileBarComponent,
    CatalogoListaDefaultComponent,
    CatalogoDetallesDefaultComponent,

    // component tools
    SwitcherComponent,
    TouchspinComponent,
    SuccessModalComponent,
    ErrorModalComponent,
    ConfirmModalComponent,
    PaginationComponent,
    DatepickerComponent,
    BotonExcelComponent,
    WarningModalComponent,
    Select2SingleComponent,
    Select2GroupsComponent,
    CatalogoObrasInversionistasGruposComponent,
    CatalogoObrasInversionistasIndividualComponent,
    CatalogoObrasFotografiaComponent,
    MovimientosObraProyeccionesComponent,
    Select2MultiComponent,
    SecurityModalComponent,
    PrintReciboModalComponent,
    PrintChequeModalComponent,
    InputCurrencyComponent,
    Select2MultiGroupsComponent,
    LiquidacionModalComponent,
    GenerarPasswordComponent,
    LoginComponent,
    RecuperarPasswordComponent,
    CerrarSessionModalComponent,
    Message1ModalComponent,
    UsuariosComponent,
    UsuariosPermisosComponent,
    TexteditorComponent,
    ChartBarComponent,
    ChartLineComponent,
    LiquidacionCapturaFondoAhorroComponent,
    LiquidacionRevisionFondoAhorroComponent,
    LiquidacionRevisionMovimientosObraComponent,
    LiquidacionRevisionNotasFotografiasComponent,
    ConfirmTextModalComponent,
    ReportePorObraComponent,
    ReporteSaldosComponent,
    ReportePorInversionistaComponent,
    ChartDonutComponent,
    ProgressBarComponent,
    ReporteResumenObraComponent,
    ReporteBalanceKRComponent,
    ReporteEquilibrioKRComponent,
    TouchspinV2Component,
    SaveImageComponent,
    ReporteResumenDeObraGruposModalComponent,
    DetallesKRModalComponent,
    DetallesBalanceKRModalComponent,
    ReporteResumenDeObraRetornosModalComponent,
    MovimientosModalComponent,
    ModalComprobantesLiquidacionComponent,
    AjaxLoaderComponent,
    SkeletonComponent,
    ModalNuevoConvenioComponent,
    ModalFacturacionComponent,
    ModalNotaCreditoComponent,
    ModalInteresesMoratoriosComponent,
    FormularioFotografiasProductoComponent,
    ModalEditarCXPComponent,
    ConfiguracionComponent,
    VisualizarContratoComponent,
    ModalVerContratoComponent,
    ModalIngresoInterno,
    ModalNuevoMovCarpetaBlancaComponent,

    TicketAyudaModalComponent,
    TicketImplementacionModalComponent,
    SobreBlancoComponent

  ],
  imports: [
    HttpModule,
    BrowserModule,
    routing,
    NgbModule.forRoot(),
    FormsModule,
    Ng2SearchPipeModule
  ],
  providers: [
    appRoutingProviders,
    GeneralServices,
    ConstantsService,
    ObrasService,
    CuentasService,
    ConceptosService,
    ProveedoresService,
    CuentasPorCobrarService,
    ChequesTemplatesService,
    InversionistasService,
    InversionistasGruposService,
    ProveedoresGruposService,
    MovimientosObraService,
    MovimientosObraProyeccionesService,
    UsuariosService,
    LiquidacionCapturaService,
    LiquidacionCapturaMovimientosObraService,
    LiquidacionCapturaFotografiasService,
    LiquidacionRevisionService,
    LiquidacionRevisionMovimientosObraService,
    LiquidacionRevisionFotografiasService,
    ReporteLiquidacionService,
    ReportesService,
    ReportePorObraService,
    ReportePorInversionistaService,
    ReporteResumenObraService,
    ReporteBalanceKRService,
    ReporteEquilibrioKRService,
    ReporteDepositoGarantiaService,
    ReporteResumenOyvService,
    ReporteCobranzaService,
    EstadoCuentaClientesService,
    HelpersService,
    ValidatorService,
    ErrorsService,
    AutenticacionService,
    AutenticacionGuard,
    ModulesService,
    Globals,
    CookieService,
    ReporteGeneralService,
    CurrencyPipe,
    DecimalPipe,
    NgbActiveModal,
    CuentasPorPagarService,
    CatalogoService,
    ReporteCuentasPorPagarService,
    CatalogosSatService,
    ProductosService,
    VentasService,
    SobreBlancoService,
    ConfiguracionesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts